module.exports = __webpack_public_path__ + "img/1-2.e421a918.png";